const systemMain = {
  title: 'A COMBAT-OPERATIONAL SYSTEM',
  description:
    'We deliver the full cycle of fielding a combat-operational UAS – from development and integration into tactical missions to training drone operators and 24/7 technical support – to ensure operational stability on the battlefield.',
  cards: {
    education: {
      title: 'UAV operator training',
      description:
        'A comprehensive training course with drills based on real combat scenarios.',
    },
    bpla: {
      title: 'Strike UAV',
      description:
        'A strike UAV that operates under active EW conditions and without GPS.',
    },
    bpak: {
      title: 'Strike System',
      description:
        'A complex for high-precision target engagement in tactical depth, resistant to EW.',
    },
  },
}

export default systemMain
